/** 로그인 429(too_many_attempts) 안내 문구. 대기 시간은 서버가 계산해 준 retryAfterSec만 쓴다(없거나 이상하면 시간 없이 안내). 계정 존재 여부는 말하지 않는다. */
export function lockoutMessage(retryAfterSec: unknown): string {
  const base = '로그인 시도가 너무 많아 잠시 잠겼어요. 지금은 다시 시도해도 계속 잠겨 있어요.';
  if (typeof retryAfterSec !== 'number' || !Number.isFinite(retryAfterSec) || retryAfterSec <= 0) return `${base} 잠시 후 다시 시도해 주세요.`;
  const sec = Math.ceil(retryAfterSec);
  const when = sec < 60 ? `${sec}초` : `${Math.ceil(sec / 60)}분`;
  return `${base} 약 ${when} 뒤에 다시 시도해 주세요.`;
}
